var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H14C14.5304 20 15.0391 19.7893 15.4142 19.4142C15.7893 19.0391 16 18.5304 16 18V6L10 0ZM5.998 12.768H4.895V16.042H3.978V12.768H2.893V12H5.998V12.768ZM8.723 16.042L8.358 15.311C8.208 15.029 8.112 14.819 7.999 14.585H7.986C7.903 14.818 7.801 15.028 7.674 15.311L7.339 16.042H6.294L7.465 13.997L6.336 12H7.386L7.74 12.738C7.861 12.983 7.95 13.181 8.046 13.409H8.059C8.155 13.151 8.233 12.971 8.335 12.738L8.676 12H9.719L8.58 13.973L9.778 16.042H8.723ZM13.107 12.768H12.003V16.042H11.086V12.768H10.001V12H13.106L13.107 12.768ZM10 7H9V2L14 7H10Z",
    fill: "#14B8A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextfile);
export default __webpack_public_path__ + "static/media/textfile.bad50513dcf2f0b148e0d617ffae9eb9.svg";
export { ForwardRef as ReactComponent };